import landscapeSrc from "./landscape.svg";
import portraitSrc from "./portrait.svg";

const peakPlaceHolder = {
  landscape: {
    src: landscapeSrc,
    srcWidth: 1920,
    srcHeight: 1280,
    alt: "",
  },
  portrait: {
    src: portraitSrc,
    srcWidth: 1280,
    srcHeight: 1920,
    alt: "",
  },
  square: {
    src: portraitSrc,
    srcWidth: 315,
    srcHeight: 315,
    alt: "",
  },
  wide: {
    src: landscapeSrc,
    srcWidth: 1000,
    srcHeight: 500,
    alt: "",
  },
};

export default peakPlaceHolder;
